import { getPaddleEnvironment } from "@/lib/paddle";

export function PaymentTestModeBanner() {
  if (getPaddleEnvironment() !== "sandbox") return null;
  return (
    <aside aria-label="Payments test mode notice" className="w-full bg-amber-100 border-b border-amber-300 px-4 py-2 text-center text-xs text-amber-900">
      Payments are in <strong>test mode</strong>. Use card 4242 4242 4242 4242 to try a checkout — no real charges.{" "}
      <a
        href="https://docs.lovable.dev/features/payments#test-and-live-environments"
        target="_blank"
        rel="noopener noreferrer"
        className="underline font-medium text-amber-950"
      >
        Learn more
      </a>
    </aside>
  );
}